import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tri-footer" }
const _hoisted_2 = { class: "tri-footer__pane" }
const _hoisted_3 = { class: "tri-footer__prev" }
const _hoisted_4 = { class: "tri-footer__next" }

interface Props {
  name?: string
  company?: string
  copyright?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterBar',
  props: {
    name: { default: '复旦软件园杭州基地' },
    company: { default: '中科润禾（浙江）信息技术有限公司' },
    copyright: { default: '中科润禾（浙江）信息技术有限公司' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createElementVNode("span", null, "建设单位：" + _toDisplayString(_ctx.name), 1)
      ]),
      _createElementVNode("p", _hoisted_4, [
        _createElementVNode("span", null, "技术支持：" + _toDisplayString(_ctx.copyright) + "©", 1)
      ])
    ])
  ]))
}
}

})